import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class NotificationsService {
	constructor(private http: HttpClient) {}

	getUserNotifications(userId: string) {
		const url = `${environment.api}notifications/get_user_notifications/${userId}`;
		return this.http.get(url);
	}

	markAsRead(notificationId: number) {
		const url = `${environment.api}notifications/mark_notification_read`;
		const formData = new FormData();
		formData.append('notification_id', notificationId.toString());
		return this.http.post(url, formData);
	}

	getAllNotifications(filters: { dateFrom?: string; dateTo?: string }) {
		const url = `${environment.api}notifications/get_all_notifications`;

		const formData = new FormData();
		if (filters.dateFrom) formData.append('date_from', filters.dateFrom);
		if (filters.dateTo) formData.append('date_to', filters.dateTo);

		return this.http.post(url, formData);
	}
}
